export const INVENTORY_RESTRICTED_BRANDS = ['proflo', 'signature hardware'];
export const MAX_RESTRICTED_INVENTORY_QUANTITY = 500;
export const MAX_DEFAULT_INVENTORY_QUANTITY = 9999;
export const MIN_INVENTORY_QUANTITY = 1;
